import styles from "./InputField.module.scss";

const Annotation = ({ children, is_caution = false, label = "" }) => {
  return (
    <div className={styles.field__annotation}>
      <label className={styles.field__label}>{label}</label>
      <span
        className={`${styles.field__annotation__span} ${
          is_caution ? styles.caution : ""
        } `}
      >
        {children}
      </span>
    </div>
  );
};
export default Annotation;
